import type { OverlayBadgeDesignTokens } from '@primeuix/themes/types/overlaybadge';

 export default {
    root: {
        outline: {
            width: "2px",
            color: "{content.background}"
        }
    }
} satisfies OverlayBadgeDesignTokens;